import { createContext, useContext } from 'react';

import { AccountFeatureFlags, GlobalProps, GlobalPropsWithAccount } from '@/models/GlobalProps';
import { globalProps } from '@/utils/globalProps';

export const GlobalPropsContext = createContext<GlobalProps>(globalProps);

export const useGlobalAccount = () => (useContext(GlobalPropsContext) as GlobalPropsWithAccount).account;
export const useAccountFeatureFlag = <K extends keyof AccountFeatureFlags>(flag: K): AccountFeatureFlags[K] =>
  (useContext(GlobalPropsContext) as GlobalPropsWithAccount).featureFlags.account[flag];
